var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"grid grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-4 md:gap-x-"},_vm._l((_vm.products),function(product){return _c('n-link',{key:product.slug,attrs:{"to":_vm.localePath({
        name: 'ville-boutique-subCategory-product',
        params: _vm.getParams(product)
      })}},[_c('ProductExerpt',{attrs:{"product":product}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }